import { render } from "./RiskRegister.vue?vue&type=template&id=34f22f12&scoped=true"
import script from "./RiskRegister.vue?vue&type=script&lang=js"
export * from "./RiskRegister.vue?vue&type=script&lang=js"

import "./RiskRegister.vue?vue&type=style&index=0&id=34f22f12&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f22f12"]])

export default __exports__